module.exports = __webpack_public_path__ + "static/media/jelly-places-twitter-600x314.d97ab617.jpg";